const StorageError = class {
    constructor(code, message) {
        this.code = code;
        this.message = message;
    }
}

export default StorageError;